import { TicketItemStatus as u } from "@ancon/wildcat-types";
function p(s) {
  return s.reduce(
    (t, e) => {
      var a;
      switch ((a = e.ticketItem) == null ? void 0 : a.status) {
        case u.Ready:
          t.ready.push(e);
          break;
        case u.Closed:
          t.done.push(e);
          break;
      }
      return t;
    },
    {
      all: s,
      ready: [],
      done: []
    }
  );
}
export {
  p as default
};
